import {type WysiwygPullQuoteComponentRecord} from '~/_generated/graphql'
import {getPullQuoteProps} from '~/cms/helpers/getPullQuoteProps'
import {HgArticleWYSIWYGPullQuote} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'
import {wysiwygComponentVariants} from '../../_utils/variants'
import {type WysiwygPullQuoteFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGPullQuoteProps = WysiwygPullQuoteFragment

export const DatoWYSIWYGPullQuote = (props: DatoWYSIWYGPullQuoteProps) => {
  const {pullQuote} = wysiwygComponentVariants()

  return (
    <HgArticleWYSIWYGPullQuote
      className={pullQuote()}
      {...getPullQuoteProps(props as WysiwygPullQuoteComponentRecord)}
    />
  )
}
